<template>
  <div>
    <Title :title="'电压电流温度监测'" :isWidth840="true"></Title>
    <Chart :cdata="cdata" :height="style.height" :width="style.width"/>
  </div>
</template>

<script>
import BigTitle from '../../bigTitle';
import Chart from '../chart.vue'
import Title from '../../title.vue'
import { dataInterface } from '@/api/dataInterfaceApi';
export default {
  data () {
    return {
      style:{
        width: '900',
        height: '250'
      },
      cdata: {
        category: [],
        rateData: [],
        id:"carAddChart",
        legendData:[{
              name:"电流",
              icon: 'roundRect',
        },{
              name:"电压",
              icon: 'roundRect',
        },{
              name:"最高温度",
              icon: 'roundRect',
        },{
              name:"最低温度",
              icon: 'roundRect',
        }],
        series:[
            {
              name: "电流",
              type: "line",
              barWidth: 10,
              itemStyle: {
                normal: {
                  color: '#01BB7B'
                }
              },
              data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
            },
            {
              name: "电压",
              type: "line",
              barWidth: 10,
              itemStyle: {
                normal: {
                  color: '#5B8FF9',
                }
              },
              data: []
            },
            {
              name: "最高温度",
              type: "line",
              barWidth: 10,
              itemStyle: {
                normal: {
                  color: '#FF9502',
                }
              },
              data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
            },
            {
              name: "最低温度",
              type: "line",
              barWidth: 10,
              itemStyle: {
                normal: {
                  color: '#B8E986',
                }
              },
              data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
            },
        ],
        yAxisname:""
      }
    };
  },
  components: {
    BigTitle,
    Chart,
    Title
  },
  mounted () {
  },
  methods: {
    getData(data){
      this.selectBatteryDetectionInfo(data)
    },
    selectBatteryDetectionInfo(data={}){
      let _this = this;
      let date = new Date();
      let ts = "";
      let year = date.getFullYear();
      let mouth = date.getMonth()+1;
      let  params = {
          "enCode":"TD-congdiancang-dianchijiance",
          "@bn":data.batteryId,
          "@ts":year+"-"+mouth+"-01 00:00:00"
      }
      dataInterface
        .dataFaceApi(params)
        .then((res) => {
          if(!res) return;
          console.log("电压电流",res);
          let chgOutputCurrList=[];
          let chgOutputVoltList=[];
          let maximumMonomerList=[];
          let minimumMonomerList=[];
          let xList=[];
          res.map(item=>{
            chgOutputCurrList.push(item.vi);
            chgOutputVoltList.push(item.vt);
            maximumMonomerList.push(item.maxtemp);
            minimumMonomerList.push(item.mintemp);
            xList.push(item.shijian);
          })
          this.cdata.series[0].data = chgOutputCurrList;//电流
          this.cdata.series[1].data = chgOutputVoltList;//电压
          this.cdata.series[2].data = maximumMonomerList;//最高温度
          this.cdata.series[3].data = minimumMonomerList;//最低温度
          this.cdata.category = xList;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    
    
  }
};
</script>

<style lang="scss" scoped>
</style>